import { use } from "react";
import FieldCitationButton from "../../../../common/document-preview/FieldCitationButton";
import WorkflowFieldCitationContext from "./WorkflowFieldCitationContext";

interface Props {
  fieldName: string;
  tooltip?: string;
}

const WorkflowFieldCitationButton = ({ fieldName, tooltip }: Props) => {
  const fieldCitation = use(WorkflowFieldCitationContext);

  if (!fieldCitation?.citationFieldIds.has(fieldName)) {
    return null;
  }

  const isActive = fieldCitation.activeCitationKey === fieldName;

  return (
    <FieldCitationButton
      active={isActive}
      tooltip={tooltip}
      onClick={isActive ? undefined : () => fieldCitation.viewFieldCitation(fieldName)}
    />
  );
};

export default WorkflowFieldCitationButton;
